import { z } from "zod"

export function createSortSchema<T extends Readonly<string[]>>(
  fields: T,
  defaultValue?: T[number],
  defaultOrder?: "asc" | "desc",
) {
  return z.object({
    sortBy: z
      .object({
        field: z
          .union(
            // No sé, Rick ¯\_(ツ)_/¯
            fields.map((field) => z.literal(field)) as unknown as [
              z.ZodLiteral<T[number]>,
              z.ZodLiteral<T[number]>,
              ...z.ZodLiteral<T[number]>[],
            ],
          )
          .default(defaultValue ?? fields[0] ?? "")
          // Gracefully fall back to the default when an invalid value is
          // received (e.g. stale bookmarks or manually crafted URLs).
          .catch(defaultValue ?? fields[0] ?? ""),
        order: z
          .union([z.literal("asc"), z.literal("desc")])
          .default(defaultOrder ?? "asc")
          .catch(defaultOrder ?? "asc"),
      })
      .default({
        field: defaultValue ?? fields[0] ?? "",
        order: defaultOrder ?? "asc",
      }),
  })
}
